// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-primary {
  background: #c23d25;
  color: #fff;
}

.btn-primary:hover {
  background: #a53520;
}
.btn-secondary {
  background: #fff;
  color: #EE5B43;
}

.btn-secondary:hover {
  background: #f5f5f5;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/Button/Button.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".btn-primary {\n  background: #c23d25;\n  color: #fff;\n}\n\n.btn-primary:hover {\n  background: #a53520;\n}\n.btn-secondary {\n  background: #fff;\n  color: #EE5B43;\n}\n\n.btn-secondary:hover {\n  background: #f5f5f5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
